import router from './router'
import store from './store'

import { Message } from 'element-ui'
import NProgress from 'nprogress'
// import { routeInfo } from '@/store/modules/route-info'
import { getToken, TokenKey, setToken, setUserInfo, getUserInfo } from '@/utils/auth' // 验权
import { getCurrentUserInfo } from '@/api/login'
import { getQueryObject } from '@/utils/index'

const whiteList = ['/login', '/404', '/register', '/print', '/print/span', '/print/span1', '/print/pick-face'] // 设置白名单，避免死循环

function checkPermission(router) {
    if (whiteList.indexOf(router.path) !== -1) {
        return true
    }
    // 刷新浏览器时，路由的path存在后缀多加/的情况，需要做下去除
    const nextPath = router.path.endsWith('/') ? router.path.substring(0, router.path.length - 1) : router.path
    return checkParentAndChildren(store.getters.routePermission, nextPath)
}

function checkParentAndChildren(routes, nextPath) {
    return routes.some(item => {
        if (item.path === nextPath) {
            return true
        } else if (item.children && item.children.length > 0 && checkParentAndChildren(item.children, nextPath)) {
            return true
        } else {
            return false
        }
    })
}

router.beforeEach(async (to, from, next) => {
    //进度环显示隐藏
    NProgress.configure({ showSpinner: false })
    NProgress.configure({ minimum: 0.7 })
    NProgress.start()
    // 先在url取token
    let token = ''
    if (getQueryObject()[TokenKey]) {
        // 外链进来挂着token
        // 先获取token
        token = getQueryObject()[TokenKey]
        if (token) {
            setToken(token)
            // 在拿用户信息
            let { code, data, msg } = await getCurrentUserInfo()
            if (+code === 0) {
                // cookie userInfo
                data.loginToken = token
                data.companyId = data.merchantId // 设置用户公司id
                setUserInfo(JSON.stringify(data))
            } else {
                Message.error(msg || '获取用户信息失败')
            }
        }
    } else if (getToken()) {
        token = getToken()
    }

    if (token) {
        if (to.path === '/login') {
            next()
        } else {
            const currentUser = getUserInfo() && JSON.parse(getUserInfo())
            const user = currentUser.name

            // if (user) {
            //     // 测试使用
            //     // const menu = routeInfo
            //     // store.dispatch('GenerateRoutes', menu)
            //     store.dispatch('SetUserInfo', currentUser)
            // }

            if (!user) {
                next('/login')
                store.dispatch('LogOut')
            } else {
                // 测试使用
                // const menu = routeInfo
                // store.dispatch('GenerateRoutes', menu)

                const menus = await store.dispatch('GetMenu', {}) // 每次切换路由都要请求？去拿取权限路由
                // 用户管理员身份（userType == 3），是不能进首页 /home 的
                if (currentUser.userType != 3) {
                    menus.unshift({
                        name: 'Home',
                        path: '/home',
                        id: 1,
                        hidden: false,
                        meta: { title: '首页', affix: true, icon: 'sidebar-home' },
                        children: null
                    })
                }
                // menus ： 服务端配置好的当前角色下的路由权限
                store.dispatch('GenerateRoutes', menus) // SET_ROUTERS 一下，最终要给 sliderbar 渲染菜单栏（routePermission）
                findButtons(menus, to.path) // 当前页面按钮权限
                store.dispatch('SetUserInfo', currentUser) // cookies里边取出来存到store中

                if (checkPermission(to)) {
                    next()
                } else {
                    next({
                        path: '/404'
                    })
                }
            }
        }
    } else {
        if (to.path === '/login' || to.path === '/forget' || to.path === '/register') {
            next()
        } else {
            next('/login') // 否则全部重定向到登录页
            // next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
        }
    }
})

router.afterEach(() => {
    setTimeout(() => {
        NProgress.done()
    }, 200)
})

function findButtons(menus, path) {
    menus.map(menu => {
        if (menu.path === path) {
            let buttons = {}
            if (menu.children && menu.children.length) {
                menu.children.map(item => {
                    console.log('%c Line:132 🥖 item', 'color:#b03734', item)
                    buttons = {
                        ...buttons,
                        [item.meta.title]: {
                            title: item.meta.title,
                            path: item.path,
                            target: item.target
                        }
                    }
                })
            }
            store.commit('SET_BUTTONS', buttons)
            console.log('buttons:', buttons)
        } else if (menu.children && menu.children.length) {
            findButtons(menu.children, path)
        }
    })
}
